// import React, { useEffect } from 'react';

// import PropTypes from 'prop-types';
// import { Form, FormSpy } from 'react-final-form';
// import { FormattedMessage } from 'react-intl';
// import { connect } from 'react-redux';

// import { Button, Feedback, PointsProgramField } from 'components';
// import {
//   BusinessCategoriesField,
//   BusinessInfoFieldGroup,
//   BusinessLogosFieldGroup,
//   LocationFieldGroup,
//   ReferralCodeGenerator,
//   JoinLoyaltyPointsField,
// } from 'containers';
// import { actions as referralCodesActions } from 'coupon-common/src/modules/referralCodes';
// import { actions as signupActions } from 'coupon-common/src/modules/signup';
// import { dispatchAsAsync } from 'coupon-common/src/utils';

// import messages from './messages';

// const SignUpForm = ({
//   onSubmitSuccess,
//   referralFormRedirect,
//   businessCode,
//   code,
//   referralInfo,
//   dispatch,
// }) => {
//   useEffect(() => {
//     dispatch(referralCodesActions.resetCodeGenerator());
//   }, [dispatch]);

//   if (!businessCode) {
//     referralFormRedirect();
//   }

//   const onSubmit = async values => {
//     if (!code) {
//       dispatch(referralCodesActions.generateCode());
//       dispatch(referralCodesActions.openCodeGenerator());
//       return;
//     }

//     const submitErrors = await dispatchAsAsync(
//       signupActions.signUp(values),
//       dispatch,
//     );

//     if (!submitErrors && onSubmitSuccess) {
//       onSubmitSuccess();
//     }

//     return submitErrors;
//   };

//   const earnPoints =
//     referralInfo.data && referralInfo.data.first_level_referral_points;

//   return (
//     <Form
//       onSubmit={onSubmit}
//       render={({ form, submitting, submitError, handleSubmit, hasValidationErrors, submitFailed }) => (
//         <form onSubmit={handleSubmit}>
//           <BusinessInfoFieldGroup />
//           {/* <JoinLoyaltyPointsField /> */}
//           <LocationFieldGroup />
//           <BusinessLogosFieldGroup />
//           <BusinessCategoriesField />
//           <ReferralCodeGenerator onConfirm={() => form.submit()} />


//           {/* 👇 Add this anywhere inside the form to inspect values */}
//       <FormSpy subscription={{ values: true }}>
//         {({ values }) => {
//           console.log('Form values:', values);
//           return null; // No UI, just console logging
//         }}
//       </FormSpy>

//           {/* <PointsProgramField earnPoints={earnPoints} /> */}
//           <Feedback show={!!submitError} content={submitError} invalid />

//           {(hasValidationErrors && submitFailed) && (
//             <div className="text-danger mb-3">
//               <FormattedMessage {...messages.validationErrorText} />
//             </div>
//           )}

//           <div className="row justify-content-between mt-4 mb-4">
//             <div className="col-xl-9 col-md-7 align-items-center">
//               <FormattedMessage
//                 tagName="p"
//                 {...messages.agreementText}
//                 values={{
//                   linkToBusinessTerms: msg => (
//                     <a
//                       href="/terms-of-service/business"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       {msg}
//                     </a>
//                   ),
//                   linkToPrivacyPolicy: msg => (
//                     <a
//                       href="/privacy-policy"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       {msg}
//                     </a>
//                   ),
//                 }}
//               />
//             </div>
//             <div className="col-xl-3 col-md-5">
//               <div className="d-flex justify-content-end">
//                 <Button fetching={submitting} type="submit">
//                   <FormattedMessage {...messages.signUpButtonText} />
//                 </Button>
//               </div>
//             </div>
//           </div>
//         </form>
//       )}
//     />
//   );
// };

// SignUpForm.propTypes = {
//   onSubmitSuccess: PropTypes.func,
//   referralFormRedirect: PropTypes.func,
//   businessCode: PropTypes.string,
//   code: PropTypes.string,
//   referralInfo: PropTypes.object,
//   dispatch: PropTypes.func,
// };

// const mapStateToProps = state => ({
//   businessCode: state.referralCodes.businessCode,
//   code: state.referralCodes.codeGenerator.code,
//   referralInfo: state.memberships.referralInfo,
// });

// export default connect(mapStateToProps)(SignUpForm);



import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { Button, Feedback } from 'components';
import { actions as signupActions } from 'coupon-common/src/modules/signup';
import { dispatchAsAsync } from 'coupon-common/src/utils';

import messages from './messages';
import Step1_Email from './Step1_Email/Step1_Email';
import Step2_UserDetails from './Step2_UserDetails/Step2_UserDetails';
import Step3_ProfileSettings from './Step3_ProfileSettings/Step3_ProfileSettings';
import Step4_JoinLoyaltyPoints from './Step4_JoinLoyaltyPoints/Step4_JoinLoyaltyPoints';


const SignUpForm = ({
  onSubmitSuccess,
  dispatch,
  businessCode,
  code,
  referralInfo,
  setSignUpFlowActive,
}) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const totalSteps = 4;

  const handleNext = (data) => {
    setFormData(prev => ({ ...prev, ...data }));
    setStep(prev => prev + 1);
  };

  const handleSkip = () => {
    setStep(prev => prev + 1);
  }

  const handleBack = () => {
    setStep(prev => Math.max(1, prev - 1));
  };

  const onSubmit = async (values) => {
    const payload = { ...formData, ...values };
    const submitErrors = await dispatchAsAsync(signupActions.signUp(payload), dispatch);
    if (!submitErrors && onSubmitSuccess) {
      onSubmitSuccess();
    }
    return submitErrors;
  };

  return (
    <div style={styles.container}>
      {(() => {
        switch (step) {
          case 1:
            return (
              <Step1_Email
                initialValues={{ email: formData.email }}
                onNext={handleNext}
                currentStep={step}
                totalSteps={totalSteps}
              />
            );
          case 2:
            return (
              <Step2_UserDetails
                initialValues={formData}
                onBack={handleBack}
                onNext={handleNext}
                onSkip={handleSkip}
                currentStep={step}
                code={code}
                totalSteps={totalSteps}
                setSignUpFlowActive={setSignUpFlowActive}
              />
            );
          case 3:
            return (
              <Step3_ProfileSettings
                initialValues={formData}
                onBack={handleBack}
                onNext={handleNext}
                onSkip={handleSkip}
                currentStep={step}
                totalSteps={totalSteps}
              />
            );
          case 4:
            return (
              <Step4_JoinLoyaltyPoints
                initialValues={formData}
                onBack={handleBack}
                onSkip={() => onSubmit(formData)} // maybe later = submit or skip final
                currentStep={step}
                totalSteps={totalSteps}
                setSignUpFlowActive={setSignUpFlowActive}
              />
            );
          default:
            return <div>Something went wrong.</div>;
        }
      })()}
    </div>
  );
};

const isMobile = window.innerWidth <= 768;

const styles = {
  container: {
    margin: '2rem auto',
    width: '100%',
    padding: isMobile ? '0' : '2rem',
  },
};


SignUpForm.propTypes = {
  onSubmitSuccess: PropTypes.func,
  dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
  businessCode: state.referralCodes.businessCode,
  code: state.referralCodes.codeGenerator.code,
  referralInfo: state.memberships.referralInfo,
});

export default connect(mapStateToProps)(SignUpForm);
